import { observabilityContextFromRecord } from './context'
import { sanitizeMetricContext } from './metrics'
import type { CanonicalIdPaths } from './redaction'
import type { ObservabilityContext } from './types'

const CORRELATION_IDS = [
  'requestId',
  'operationId',
  'orgId',
  'brandId',
  'userId',
  'chatId',
  'emailId',
  'automationId',
  'executionId',
  'sendId',
] as const satisfies ReadonlyArray<keyof ObservabilityContext>

/**
 * Reviewed diagnostic ID fields only, never arbitrary nested payloads. Caller
 * request IDs (and copies) retain token filtering unless they have our minted
 * request shape. The ordinary sanitizer still enforces ID shape and secrets.
 */
export function rumCorrelationIdPaths(
  value: unknown
): CanonicalIdPaths | undefined {
  try {
    const original = observabilityContextFromRecord(value)
    const validated = sanitizeMetricContext(original)
    if (!validated) {
      return
    }
    const requestId = validated.requestId
    const untrustedRequestId =
      requestId && !/^req_[0-9a-f]{32}$/.test(requestId) ? requestId : undefined
    const paths: Record<string, true> = {}
    for (const key of CORRELATION_IDS) {
      const identifier = validated[key]
      if (
        typeof identifier === 'string' &&
        identifier === original[key] &&
        identifier !== untrustedRequestId
      ) {
        paths[key] = true
      }
    }
    return paths
  } catch {
    return undefined
  }
}
